class BESSAppAccountEmailPreferences extends BESSAppBase {


    constructor() {
        super();
        this.root = $('.app-account-email-preferences');
        if (this.root.length === 0) {
            return;
        }
        this.emailPrefrencesInput = this.root.find('#id_email_preferences');
        this.emailPrefrencesInput.change(this.#updatePreference.bind(this));
        this.emailSubmissionsInput = this.root.find('#id_email_submissions');
        this.emailSubmissionsInput.change(this.#updatePreference.bind(this));
    }

    #updatePreference() {
        let setting = ('' + this.emailPrefrencesInput.val()) === '1';
        let setting2 = ('' + this.emailSubmissionsInput.val()) === '1';
        BESSApp.instance.services.api.auth.updateUserEmailPreference(setting, setting2);
    }
}